export default __webpack_public_path__ + "static/tessa1-aae258fa2ef9a0a523a26f0933f8c612.jpg";